import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Owner } from "../../types/modules/admin/Owner";

interface UseParams {
  page?: number;
  limit?: number;
  name?: string;
  email?: string;
  phone?: string;
  city?: string;
  isCompletedProfile?: string;
}

export const useOwnersByAdmin = ({
  page = 1,
  limit = 10,
  name = "",
  email = "",
  city = "",
  phone = "",
  isCompletedProfile = "",
}: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    phone: phone,
    name: name,
    email: email,
    city: city,
    isCompletedProfile:
      isCompletedProfile === "complete"
        ? "true"
        : isCompletedProfile === "uncomplete"
        ? "false"
        : "",
  });
  return useQuery({
    queryKey: [
      "owners-by-admin",
      page,
      limit,
      name,
      email,
      city,
      phone,
      isCompletedProfile,
    ],
    queryFn: () =>
      fetcher<{ data: Owner[]; total: number; totalPages: number }>(
        `owner/all?${queryParams.toString()}`,
        token
      ),
  });
};
